var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.977,
    height: 13.466,
    viewBox: "0 0 14.977 13.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52676",
    d: "M2,7.484A4.483,4.483,0,0,1,6.493,3h5.991a4.494,4.494,0,0,1,4.493,4.484v8.981H6.493A4.494,4.494,0,0,1,2,11.981Zm13.479,7.485V7.484a3,3,0,0,0-3-2.988H6.493a2.986,2.986,0,0,0-3,2.988v4.5a3,3,0,0,0,3,2.988ZM10.986,8.985h1.5v1.5h-1.5Zm-4.493,0h1.5v1.5h-1.5Z",
    transform: "translate(-2 -3)",
    fill: "#676868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a3eb6cff9b23203530379160d2b75d8d.svg";
export { ForwardRef as ReactComponent };